import React from 'react';
import '../pages/List.css';
import '../App.css';
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Button
} from '@material-ui/core';

import { makeStyles, createStyles } from '@material-ui/core/styles';

export const MemoDialog = (props: any) => {
  const useStyles = makeStyles(() =>
    createStyles({
      remarksInput: {
        height: 100,
        maxHeight: 150,
        minWidth: 350,
        borderColor: '#c1c1c1',
        borderWidth: 1
      }
    })
  );

  const classes = useStyles();

  return (
    <Dialog
      open={props.openMemoDialog}
      onClose={props.handleCloseMemoDialog}
      scroll='paper'
      aria-labelledby='set_construct_title'
      aria-describedby='constructs'
    >
      <DialogTitle id='set_construct_title'>メモ</DialogTitle>
      <DialogContent dividers>
        <textarea
          value={props.memoDialog}
          maxLength={15}
          placeholder='15文字以内'
          onChange={text => {
            props.setMemoDialog(text.target.value);
          }}
          className={classes.remarksInput}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleCloseMemoDialog} color='primary'>
          キャンセル
        </Button>
        <Button
          onClick={() => {
            props.updateMemo();
          }}
          color='primary'
        >
          保存
        </Button>
      </DialogActions>
    </Dialog>
  );
};
